// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"310":"surveys-home","872":"surveys-detail"}[chunkId] || chunkId) + ".js";
};